module.exports = __webpack_public_path__ + "img/38.51c9ab24.jpg";